import api from './utilBackoffice';

const controller = 'TipoContratoBMP';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  GetInput: dto => {
    return api.Axios.GetParams(url + '/Input', dto);
  },
  GetAllTipoContratoBMP: dto => {
    return api.Axios.GetParams(url + '/GetAllTipoContratoBMP', dto);
  }
});
